import React from 'react';
import { REPORT } from '../print/PrintAtoms';
import type { SlopeGrids } from '../../lib/api';
import { formatPublished } from './slopeRange';

// The one statement of how slope is measured, on every briefing with a slope file
// (.claude/rules/terrain-slope.md). Keep the wording in step with that rule.
export const SlopeMethodNote: React.FC<{ grids: SlopeGrids }> = ({ grids }) => {
  const published = formatPublished(grids.source.published);
  return (
    <div className="no-break" style={{ margin: '0 0 10px', padding: '8px 12px', background: REPORT.surface, border: `1px solid ${REPORT.rule}`, borderRadius: 6, fontSize: '10px', color: REPORT.secondary, lineHeight: 1.5 }}>
      <strong style={{ color: REPORT.heading }}>How slope is measured.</strong>{' '}
      {grids.source.status === 'lidar_1m'
        ? `From USGS 3DEP 1 m lidar over the site's exact footprint, with the ground averaged to 3 m and 5 m grids before slope is calculated, shown as a range across the two. The raw 1 m grid reads inch-scale ground roughness as steepness; 3 to 5 m matches how grading plans measure slope. ${grids.source.label}${published ? `, published ${published}` : ''}. Figures describe distributed area, not a contiguous pad.`
        : 'No USGS 1 m lidar covers this site, so the slope figures are a 10 m terrain screen, not a site-grade measurement.'}
    </div>
  );
};
